import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=53d9e48a&scoped=true"
import script from "./PollList.vue?vue&type=script&lang=js"
export * from "./PollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9e48a",
  null
  
)

export default component.exports